import React from 'react';
import Courses from '../../../components/Courses';
import '../css/AllCourses.css';

function AllCourses() {
  return (
    <section className="courses-page">
      <Courses />
    </section>
  );
}

export default AllCourses;
